import * as React from 'react'
import './index.scss'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import _ from 'lodash';
import NumbersIcon from '@mui/icons-material/Numbers';
import {useAppDispatch, useAppSelector} from "../../redux";
import {useEffect} from "react";
import {getLiveOdds} from "../../redux/slices/fixtures";
import {FETCH_INTERVAL} from "../../utils";

function a11yProps(index: number) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

export default function Odds(props: any) {
    const dispatch = useAppDispatch()
    const [prevProps, setPrevProps] = React.useState(props);

    const [expandedLive, setExpandedLive] = React.useState(true);
    const [activeSource, setActiveSource] = React.useState('sofascore');
    const [expandedPreMatch, setExpandedPreMatch] = React.useState(true);
    const marketsOnTwoColumns = ['Goluri prima repriză', 'Total goluri', 'Rezultat meci', 'Ambele echipe', 'Șansă dublă', 'Pauză/Final']

    const {activeGame} = useAppSelector(state => state.fixtures)

    useEffect(() => {
        let timer: any = null;

        const fetchDataOnInterval = async () => {
            try {
                dispatch(getLiveOdds(activeGame.id));

                if (activeGame.status.type !== 'inprogress' && timer) {
                    clearInterval(timer);
                }
            } catch (error) {
                clearInterval(timer);
            }
        };

        fetchDataOnInterval();
        timer = setInterval(fetchDataOnInterval, FETCH_INTERVAL);

        return () => {
            if (timer) {
                clearInterval(timer);
            }
        }
    }, [activeGame.id]);

    React.useEffect(() => {
        setTimeout(() => setPrevProps(props), 5000)
    }, [props]);

    const handleExpandLiveClick = () => {
        setExpandedLive(!expandedLive);
    };
    const handleExpandPreMatchClick = () => {
        setExpandedPreMatch(!expandedPreMatch);
    };

    const displayOddChange = (change) => {
        if (change === 1) {
            return <ArrowDropUpIcon className="change-up"/>
        }

        if (change === -1) {
            return <ArrowDropDownIcon className="change-down"/>
        }

        return '';
    };

    const getPreviousOdd = (prevProps, optionName, marketName, defaultValue) => {
        const line = _.cloneDeep(prevProps.data)
            .filter((m: any) => m.isLive)
            .find((opt: any) => opt.marketName === marketName)

        if (!line) {
            return defaultValue
        }

        const option = line.choices.find((opt: any) => getOptionName(opt.name) === optionName)

        if (!option) {
            return defaultValue
        }

        return option.valueDecimal
    }

    const calculateWidths = (choices) => {
        const totalOdds = choices.reduce((sum, choice) => sum + parseFloat(choice.valueDecimal), 0);
        return choices.map(choice => ({
            ...choice,
            width: `${(parseFloat(choice.valueDecimal) / totalOdds * 100).toFixed(2)}%`
        }));
    };

    const getOptionName = (name: string) => {
        if (name.includes(activeGame.homeTeam.name)) {
            return name.replace(activeGame.homeTeam.name, activeGame.homeTeam.shortName)
        }

        if (name.includes(activeGame.awayTeam.name)) {
            return name.replace(activeGame.awayTeam.name, activeGame.awayTeam.shortName)
        }

        return name;
    }

    const convertData = (data) => {
        if (!data) {
            return [];
        }

        return data.map(market => {
            const choicesWithWidths = calculateWidths(market.choices);

            return {
                name: market.marketName + (market.choiceGroup && market.choiceGroup != '0' ? ' ' + market.choiceGroup : ''),
                options: choicesWithWidths
                    .map(choice => ({
                        ...choice, name: getOptionName(choice.name), width: choice.width
                    })),
                accuracy: null, //market.isLive ? 'Accuracy 80%' : undefined,
                trainedOn: null, //market.isLive ? 'Trained on 120 games' : undefined,
                source: market.sourceId,
            };
        });
    };

    if (!props.data) {
        return null;
    }


    let liveOdds = convertData(_.cloneDeep(props.data).filter((m) => m.isLive)).filter((m) => !!m)
    const liveOddsAvailableSources = _.uniq(liveOdds.map((m) => m.source));
    let prematchOdds = convertData(_.cloneDeep(props.data).filter((m) => !m.isLive)).filter((m) => !!m)
    const prematchOddsAvailableSources = _.uniq(prematchOdds.map((m) => m.source));

    liveOdds = liveOdds.filter((m) => m.source === activeSource);
    prematchOdds = prematchOdds.filter((m) => m.source === activeSource);

    return (<div className='predictions'>
            <div className='available-sources'>
                {_.uniq([...liveOddsAvailableSources, ...prematchOddsAvailableSources])
                    .map((source, index) => (<div className='source-item'>
                            {source === 'betano' &&
                                <svg
                                    className={activeSource === 'betano' ? 'active' : ''}
                                    onClick={() => setActiveSource('betano')}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="83px" height="25px" viewBox="0 0 83 25" version="1.1"
                                    style={{height: '22px'}}
                                >
                                    <defs>
                                        <clipPath id="clip1">
                                            <path
                                                d="M 1.382812 3.820312 L 81.617188 3.820312 L 81.617188 21.179688 L 1.382812 21.179688 Z M 1.382812 3.820312 "/>
                                        </clipPath>
                                    </defs>
                                    <g id="surface1">
                                        <g clip-path="url(#clip1)" clip-rule="nonzero">
                                            <path
                                                d="M 27.71875 7.398438 C 23.085938 7.398438 19.738281 11.246094 19.738281 15.433594 C 19.738281 19.046875 22.253906 21.179688 25.585938 21.179688 C 28.917969 21.179688 30.984375 19.109375 31.636719 16.5625 C 30.742188 17.203125 29.203125 17.929688 27.46875 17.929688 C 25.984375 17.929688 24.207031 17.296875 24.03125 15.335938 C 27.757812 14.851562 30.796875 13.660156 32.449219 12.410156 C 32.472656 12.199219 32.5 11.898438 32.5 11.507812 C 32.5 9.402344 31.179688 7.398438 27.71875 7.398438 Z M 28.265625 12.703125 L 24.207031 12.703125 C 24.570312 10.832031 25.898438 9.453125 27.199219 9.453125 C 28.082031 9.453125 28.5 9.921875 28.5 11.066406 C 28.5 11.585938 28.421875 12.128906 28.265625 12.703125 Z M 75.550781 7.398438 C 70.789062 7.398438 67.40625 11.089844 67.40625 15.824219 C 67.40625 19.28125 70.113281 21.179688 73.46875 21.179688 C 78.234375 21.179688 81.617188 17.488281 81.617188 12.753906 C 81.617188 9.296875 78.910156 7.398438 75.550781 7.398438 Z M 73.625 19.074219 C 72.53125 19.074219 71.933594 18.191406 71.933594 16.523438 C 71.933594 13.222656 73.261719 9.503906 75.394531 9.503906 C 76.488281 9.503906 77.089844 10.386719 77.089844 12.050781 C 77.089844 15.355469 75.734375 19.074219 73.625 19.074219 Z M 67.222656 10.753906 C 67.222656 11.167969 67.179688 11.632812 67.082031 12.128906 L 65.375 20.921875 L 61.128906 20.921875 L 62.636719 13.171875 C 62.714844 12.78125 62.742188 12.441406 62.742188 12.128906 C 62.742188 10.90625 62.09375 10.363281 60.921875 10.363281 C 60.453125 10.363281 59.871094 10.511719 59.5 10.671875 L 57.511719 20.917969 L 53.265625 20.917969 L 55.84375 7.65625 L 60.089844 7.65625 L 59.621094 10.050781 C 60.308594 8.949219 61.84375 7.398438 63.839844 7.398438 C 65.6875 7.398438 67.222656 8.515625 67.222656 10.75 Z M 53.644531 11.617188 C 53.644531 9.222656 51.554688 7.398438 48.636719 7.398438 C 45 7.398438 43.105469 9.785156 42.542969 12.015625 C 43.683594 11.1875 45.308594 10.648438 46.710938 10.648438 C 48.023438 10.648438 49.320312 11.074219 49.320312 12.390625 C 49.320312 12.519531 49.320312 12.675781 49.296875 12.882812 C 45.949219 13.019531 41.121094 14.808594 41.121094 18.503906 C 41.121094 20.035156 42.234375 21.179688 43.953125 21.179688 C 45.667969 21.179688 47.265625 20.011719 48.203125 18.527344 L 47.738281 20.921875 L 51.980469 20.921875 L 53.53125 12.941406 C 53.609375 12.472656 53.644531 12.03125 53.644531 11.617188 Z M 48.324219 17.902344 C 47.804688 18.136719 47.136719 18.292969 46.640625 18.292969 C 45.574219 18.292969 45.050781 17.707031 45.050781 16.925781 C 45.050781 15.277344 47.003906 14.234375 48.890625 15.003906 Z M 38.785156 17.929688 C 39.347656 17.929688 39.898438 17.769531 40.613281 17.230469 C 39.957031 19.460938 38.125 21.179688 36.160156 21.179688 C 33.75 21.179688 32.988281 19.152344 33.488281 16.5625 L 34.765625 10 L 33.035156 10 L 33.488281 7.660156 L 35.226562 7.660156 L 35.707031 5.160156 L 40.074219 4.546875 L 39.464844 7.660156 L 43.101562 7.660156 C 42.832031 9.019531 41.984375 10 40.246094 10 L 39.007812 10 L 37.761719 16.425781 C 37.566406 17.410156 38.097656 17.929688 38.785156 17.929688 Z M 19.0625 14.328125 C 19.0625 17.890625 14.261719 20.921875 6.25 20.921875 L 1.382812 20.921875 L 4.707031 3.820312 L 15.390625 3.820312 C 18.402344 3.820312 20.011719 4.441406 20.011719 6.316406 C 20.011719 8.5625 16.421875 11.039062 10.765625 12.0625 L 13.851562 6.933594 L 9.140625 6.921875 L 7.085938 13.234375 L 10.335938 12.777344 L 6.207031 19.648438 L 15.941406 11.5625 C 17.839844 11.5625 19.0625 12.664062 19.0625 14.328125 Z M 19.0625 14.328125 "/>
                                        </g>
                                    </g>
                                </svg>

                            }
                            {source === 'sofascore' && <svg
                                width="158" height="24" viewBox="0 0 158 24" fill="var(--on-color-primary)"
                                className={"SvgWrapper gUGvug" + (activeSource === 'sofascore' ? ' active' : '')}
                                onClick={() => setActiveSource('sofascore')}
                            >
                                <g fill="var(--on-color-primary)" fill-rule="evenodd">
                                    <path fill="none" d="M0 0h72v12H0z"></path>
                                    <g fill="onColor.primary" fill-rule="nonzero">
                                        <path
                                            d="M24 .174A.174.174 0 0 0 23.826 0H.174A.174.174 0 0 0 0 .174v11.652c0 .096.078.174.174.174H5.82a.174.174 0 0 0 .174-.174V6.177c0-.096.078-.174.174-.174h17.646a.174.174 0 0 0 .174-.174V.174H24zM18.174 12.006a.174.174 0 0 0-.174.174v5.649a.174.174 0 0 1-.174.174H.174a.174.174 0 0 0-.174.174v5.649c0 .096.078.174.174.174H23.82a.174.174 0 0 0 .174-.174V12.18a.174.174 0 0 0-.174-.174h-5.646z"></path>
                                        <path
                                            d="M44.45 10.856c-1.083-.468-2.544-.758-4.383-.865-1.521-.089-2.569-.343-3.132-.758-.569-.415-.85-.996-.85-1.748 0-.7.293-1.28.874-1.748.587-.468 1.395-.705 2.437-.705 1.15 0 2.072.254 2.773.77.67.498 1.078 1.209 1.222 2.133.012.06.06.1.12.1h3.497c.072 0 .126-.058.12-.13-.21-1.937-.983-3.436-2.324-4.497-1.371-1.084-3.156-1.624-5.348-1.624-1.335 0-2.527.243-3.58.73-1.049.485-1.881 1.167-2.492 2.038-.611.87-.916 1.878-.916 3.016 0 1.339.299 2.405.904 3.194.605.788 1.45 1.368 2.533 1.736 1.084.367 2.371.598 3.857.687 1.449.095 2.49.35 3.132.77.64.421.958 1.067.958 1.926 0 .847-.342 1.523-1.018 2.027-.677.503-1.641.758-2.88.758-1.15 0-2.109-.26-2.87-.788-.736-.51-1.185-1.286-1.347-2.335-.006-.059-.06-.1-.12-.1H32.12a.117.117 0 0 0-.12.124c.108 1.393.521 2.56 1.246 3.496a6.68 6.68 0 0 0 2.857 2.151c1.161.468 2.437.705 3.826.705 1.485 0 2.803-.26 3.953-.788 1.15-.521 2.048-1.25 2.689-2.175.64-.93.958-1.996.958-3.211 0-1.156-.24-2.145-.725-2.963-.479-.812-1.263-1.458-2.353-1.926zM59.572 7.692c-1.084-.58-2.27-.865-3.551-.865-1.318 0-2.516.29-3.594.865-1.077.58-1.928 1.428-2.563 2.548-.628 1.12-.946 2.489-.946 4.106 0 1.618.318 2.987.946 4.107.63 1.12 1.486 1.973 2.563 2.56 1.078.586 2.276.883 3.594.883a7.35 7.35 0 0 0 3.55-.883c1.085-.587 1.953-1.44 2.606-2.56.647-1.12.976-2.489.976-4.107 0-1.617-.323-2.986-.976-4.106-.647-1.12-1.515-1.973-2.605-2.548zm-.988 9.86c-.63.747-1.485 1.114-2.563 1.114s-1.929-.373-2.546-1.114c-.622-.746-.934-1.807-.934-3.182 0-1.398.318-2.465.946-3.211.63-.747 1.474-1.114 2.534-1.114 1.078 0 1.928.373 2.563 1.114.629.746.946 1.813.946 3.211 0 1.38-.311 2.441-.946 3.182zM67.315 1.932c-.754.635-1.126 1.6-1.126 2.91V6.98a.12.12 0 0 1-.12.119h-2.042a.12.12 0 0 0-.12.118v3.016a.12.12 0 0 0 .12.119h2.042a.12.12 0 0 1 .12.118v11.057a.12.12 0 0 0 .12.119h3.27a.12.12 0 0 0 .12-.119V10.465a.12.12 0 0 1 .12-.118h3.545a.12.12 0 0 0 .12-.119V7.212a.12.12 0 0 0-.12-.118h-3.546a.12.12 0 0 1-.12-.119V5.523c0-.865.372-1.297 1.114-1.297h2.552a.12.12 0 0 0 .12-.119v-3.01a.12.12 0 0 0-.12-.119h-3.222c-1.132 0-2.072.32-2.827.954zM85.862 8.255c-1.18-.954-2.773-1.434-4.773-1.434-1.168 0-2.228.196-3.174.58-.946.386-1.719.949-2.312 1.684-.569.705-.916 1.54-1.042 2.512-.012.071.048.13.12.13h3.33c.06 0 .107-.041.12-.094a2.1 2.1 0 0 1 .874-1.322c.485-.338 1.168-.51 2.06-.51 2.042 0 3.066.848 3.066 2.537v.213a.12.12 0 0 1-.12.119h-3.749c-1.82 0-3.263.414-4.33 1.238-1.065.83-1.598 1.973-1.598 3.443 0 .918.167 1.677.503 2.275.335.599.766 1.073 1.293 1.416.527.35 1.108.593 1.743.73a8.563 8.563 0 0 0 1.808.206c1.318 0 2.42-.254 3.3-.758.473-.273.88-.587 1.228-.954.072-.077.21-.024.21.083v1.185a.12.12 0 0 0 .12.119h2.987a.12.12 0 0 0 .12-.119v-9.202c-.018-1.766-.605-3.123-1.784-4.077zm-3.773 10.47c-.575.255-1.132.386-1.67.386-.761 0-1.372-.155-1.84-.457-.467-.302-.694-.764-.694-1.392 0-.605.227-1.067.683-1.375.455-.314 1.173-.468 2.155-.468H84a.12.12 0 0 1 .12.118v.077c0 .789-.198 1.44-.587 1.956-.383.51-.868.895-1.443 1.155zM100.97 13.973c-.963-.67-2.562-1.072-4.79-1.197-.856-.035-1.503-.112-1.946-.237-.443-.118-.749-.278-.905-.48-.155-.201-.24-.456-.24-.77 0-.439.21-.8.63-1.073.419-.272 1.042-.414 1.88-.414.797 0 1.455.148 1.976.438.491.279.785.687.875 1.227.012.053.06.094.12.094h3.33c.07 0 .125-.059.119-.13-.174-1.44-.815-2.566-1.922-3.366-1.144-.823-2.641-1.238-4.498-1.238-1.168 0-2.204.196-3.102.58-.898.386-1.605.92-2.114 1.6-.509.682-.766 1.482-.766 2.4 0 1.031.251 1.85.754 2.454.503.604 1.216 1.048 2.144 1.32.928.274 2.042.44 3.342.499 1.203.053 2.012.207 2.425.456.407.249.61.628.61 1.144 0 .515-.227.924-.682 1.226-.455.302-1.174.456-2.156.456-.874 0-1.61-.142-2.216-.426-.574-.273-.904-.694-1-1.268a.122.122 0 0 0-.12-.095h-3.305a.117.117 0 0 0-.12.124c.072 1.025.407 1.879.994 2.548.611.7 1.414 1.221 2.408 1.57.994.35 2.102.522 3.33.522 1.353 0 2.508-.213 3.467-.634.958-.42 1.682-1.001 2.185-1.736a4.284 4.284 0 0 0 .755-2.483c-.018-1.41-.497-2.441-1.461-3.11zM112.69 18.174a3.872 3.872 0 0 1-1.922.498c-1.078 0-1.928-.367-2.545-1.102-.623-.735-.934-1.801-.934-3.194 0-1.398.317-2.465.946-3.212.629-.746 1.473-1.114 2.533-1.114.779 0 1.437.196 1.976.581.515.373.863.948 1.036 1.724.012.054.06.095.12.095h3.36c.072 0 .131-.065.12-.136-.258-1.843-.989-3.212-2.18-4.106-1.228-.919-2.72-1.375-4.486-1.375a7.25 7.25 0 0 0-3.467.853c-1.066.569-1.928 1.416-2.587 2.536-.659 1.12-.988 2.5-.988 4.136 0 1.636.317 3.01.946 4.136.629 1.12 1.48 1.968 2.545 2.548 1.066.581 2.252.865 3.551.865 1.06 0 2.06-.19 3.007-.563a5.919 5.919 0 0 0 2.395-1.748c.623-.758 1.06-1.7 1.305-2.832.018-.071-.041-.142-.12-.142h-3.353a.115.115 0 0 0-.114.089c-.191.652-.575 1.143-1.144 1.463zM129.44 7.692c-1.083-.58-2.27-.865-3.55-.865-1.318 0-2.516.29-3.594.865-1.078.58-1.928 1.428-2.563 2.548-.629 1.12-.946 2.489-.946 4.106 0 1.618.317 2.987.946 4.107s1.485 1.973 2.563 2.56c1.078.586 2.276.883 3.593.883a7.35 7.35 0 0 0 3.552-.883c1.083-.587 1.952-1.44 2.605-2.56.646-1.12.976-2.489.976-4.107 0-1.617-.324-2.986-.976-4.106-.653-1.12-1.522-1.973-2.605-2.548zm-.988 9.86c-.628.747-1.485 1.114-2.563 1.114s-1.928-.373-2.545-1.114c-.623-.746-.934-1.807-.934-3.182 0-1.398.317-2.465.946-3.211.629-.747 1.473-1.114 2.533-1.114 1.078 0 1.929.373 2.563 1.114.63.746.947 1.813.947 3.211 0 1.38-.318 2.441-.947 3.182zM138.92 7.852a5.3 5.3 0 0 0-.646.74c-.066.096-.216.048-.216-.07v-1.31a.12.12 0 0 0-.12-.118h-3.018a.12.12 0 0 0-.12.118v14.31a.12.12 0 0 0 .12.119h3.27a.12.12 0 0 0 .12-.119v-8.224c0-.717.113-1.292.335-1.725.222-.432.52-.746.892-.936.372-.195.797-.29 1.282-.29h2.695a.12.12 0 0 0 .12-.119V7.212a.12.12 0 0 0-.12-.118h-2.222c-1.042.006-1.833.254-2.372.758zM157.108 10.252c-.593-1.132-1.408-1.985-2.438-2.56-1.03-.575-2.185-.865-3.467-.865a6.852 6.852 0 0 0-3.455.907c-1.06.604-1.91 1.47-2.546 2.589-.64 1.12-.958 2.471-.958 4.053 0 1.618.306 2.987.917 4.106.61 1.12 1.437 1.968 2.479 2.548 1.042.581 2.198.866 3.48.866 1.634 0 3.06-.397 4.287-1.186 1.192-.764 1.97-1.937 2.335-3.52.018-.07-.041-.142-.12-.142h-3.383a.122.122 0 0 0-.114.083c-.191.581-.533 1.002-1.03 1.25-.52.267-1.15.398-1.892.398-1.132 0-1.988-.38-2.575-1.132-.437-.563-.713-1.321-.82-2.264a.119.119 0 0 1 .12-.13h9.916c.06 0 .108-.041.12-.1.024-.113.036-.226.036-.333v-.456c0-1.612-.3-2.98-.892-4.112zm-5.935-.427c1.096 0 1.898.338 2.407 1.02.33.432.551.977.665 1.623a.122.122 0 0 1-.12.142h-6.042c-.078 0-.138-.07-.114-.148.15-.575.371-1.066.677-1.463.587-.783 1.431-1.174 2.527-1.174z"></path>
                                    </g>
                                </g>
                            </svg>}
                        </div>))}
            </div>

            {liveOdds.length !== 0 ? <div className="live-wrapper">
                <div className="live">
                    <div className="title" onClick={(e: any) => handleExpandLiveClick()}>
                        <div className='name'>
                            <span className='red-dot'></span>
                            <div>Live</div>
                        </div>
                        <ExpandMore
                            expand={expandedLive}
                            aria-expanded={expandedLive}
                        >
                            <ExpandMoreIcon/>
                        </ExpandMore>
                    </div>
                </div>
                <Collapse in={expandedLive} timeout="auto" unmountOnExit>
                    <div className="options">
                        {liveOdds.map((option: any, index: number) => (<div className="option" key={index}>
                                <div className="name">{option.name}</div>
                                <div className="value">
                                    {option.options
                                        .reduce((result, item, index) => {
                                            let defaultGroup = 3;
                                            for (const groupIndex1 of marketsOnTwoColumns) {
                                                if (option.name.indexOf(groupIndex1) > -1) {
                                                    defaultGroup = 2;
                                                }
                                            }

                                            const groupIndex = Math.floor(index / defaultGroup);
                                            if (!result[groupIndex]) {
                                                result[groupIndex] = [];
                                            }
                                            result[groupIndex].push(item);
                                            return result;
                                        }, [])
                                        // recalculate the width, so the 3 odds end up with width 100%
                                        .map((opt: any) => calculateWidths(opt))
                                        .map((opt: any) => <div style={{display: 'flex', marginBottom: '7px'}}>
                                            {opt.map((o: any, indx: number) => (<div
                                                    className={(indx === 0 ? "home" : indx === 1 ? "draw" : "away") + (o.winning ? ' odd-won' : '')}
                                                    style={{width: o.width}}>
                                                    <div>{o.name}</div>
                                                    <div>{displayOddChange(o.change)} {o.valueDecimal}</div>
                                                </div>))}
                                        </div>)}
                                </div>
                                {option.accuracy &&
                                    <div className="accuraccy" style={{width: '80%'}}>{option.accuracy}</div>}
                                {option.trainedOn && <div className="trained-on">{option.trainedOn}</div>}
                            </div>))}
                    </div>
                </Collapse>
            </div> : ''}

            <div className="pre-match">
                <div className="title" onClick={(e: any) => handleExpandPreMatchClick()}>
                    <div className='name'>Pre-match</div>
                    <ExpandMore
                        expand={expandedPreMatch}
                        aria-expanded={expandedPreMatch}
                    >
                        <ExpandMoreIcon/>
                    </ExpandMore>
                </div>
            </div>

            <Collapse in={expandedPreMatch} timeout="auto" unmountOnExit>
                <div className="options">
                    {prematchOdds.map((option: any, index: number) => (<div className="option" key={index}>
                            <div className="name">{option.name}</div>
                            <div className="value">
                                {option.options
                                    .reduce((result, item, index) => {
                                        let defaultGroup = 3;
                                        for (const groupIndex1 of marketsOnTwoColumns) {
                                            if (option.name.indexOf(groupIndex1) > -1) {
                                                defaultGroup = 2;
                                            }
                                        }

                                        const groupIndex = Math.floor(index / defaultGroup);
                                        if (!result[groupIndex]) {
                                            result[groupIndex] = [];
                                        }
                                        result[groupIndex].push(item);
                                        return result;
                                    }, [])
                                    // recalculate the width, so the 3 odds end up with width 100%
                                    .map((opt: any) => calculateWidths(opt))
                                    .map((opt: any) => <div style={{display: 'flex', marginBottom: '7px'}}>
                                        {opt.map((o: any, indx: number) => (<div
                                                className={(indx === 0 ? "home" : indx === 1 ? "draw" : "away") + (o.winning ? ' odd-won' : '')}
                                                style={{width: o.width}}>
                                                <div>{o.name}</div>
                                                <div>{displayOddChange(o.change)} {o.valueDecimal}</div>
                                            </div>))}
                                    </div>)}
                            </div>
                        </div>))}

                    {prematchOdds.length === 0 && <div className="no-available-games">
                        <NumbersIcon/>
                        <h4>No odds available for this game.</h4>
                    </div>}
                </div>
            </Collapse>

            {/*<div className="odds-provider">*/}
            {/*    <div className="title">Odds provided by <img src="https://mrbit.ro/web_assets/b92ca3d78fe44c1477b4.svg"/></div>*/}
            {/*</div>*/}
        </div>)
}
